import dashboard from "@/assets/icons/SVG/Home white.svg";
// import quotes from "@/assets/icons/SVG/Quote white.svg";
import inboundShipment from "@/assets/icons/SVG/inbound white.svg";
import orders from "@/assets/icons/SVG/orders white.svg";
import returns from "@/assets/icons/SVG/Returns white.svg";
import support from "@/assets/icons/SVG/Support white.svg";
import inventory from "@/assets/icons/SVG/inventory.svg";
import integration from "@/assets/icons/SVG/integration.svg";
import profile from "@/assets/icons/SVG/Profile white.svg";
// import freight from "@/assets/icons/SVG/freight-shipping.png";

export const menuItems = [
  {
    id: "dashboard",
    label: "menuitems.dashboard.text",
    icon: dashboard,
    link: "/dashboard",
    height: "23",
  },
  // {
  //   id: "quote",
  //   label: "menuitems.quote.text",
  //   icon: quotes,
  //   height: "27",
  //   link: "/quotes",

  // subItems: [
  //   {
  //     label: "menuitems.quote.list.list",
  //     link: "/quotes/list",
  //   },
  //   {
  //     label: "menuitems.quote.list.request",
  //     link: "/quotes/create",
  //   },
  // ],
  // },
  {
    id: "inbounds",
    label: "menuitems.inbound-shipments.text",
    icon: inboundShipment,
    height: "14",
    link: "/inbound-shipments",

    // subItems: [
    //   {
    //     label: "menuitems.inbound-shipments.list.list",
    //     link: "/inbound-shipments",
    //   },
    //   {
    //     label: "menuitems.inbound-shipments.list.create",
    //     link: "/inbound-shipments/create",
    //   },
    // ],
  },
  {
    id: "orders",
    label: "menuitems.orders.text",
    icon: orders,
    height: "22",
    link: "/orders",

    // subItems: [
    //   {
    //     label: "menuitems.orders.list.list",
    //     link: "/orders",
    //   },
    //   {
    //     label: "menuitems.orders.list.create",
    //     link: "/orders/create",
    //   },
    // ],
  },
  {
    id: "returns",
    label: "menuitems.returns.text",
    icon: returns,
    height: "25",
    link: "/order-returns",

    // subItems: [
    //   {
    //     label: "menuitems.returns.list.list",
    //     link: "/order-returns",
    //   },
    //   {
    //     label: "menuitems.returns.list.create",
    //     link: "/order-returns/create",
    //   },
    // ],
  },
  {
    id: "support-tickets",
    label: "menuitems.support-tickets.text",
    icon: support,
    height: "23",
    link: "/support-tickets",

    // subItems: [
    //   {
    //     label: "menuitems.support-tickets.list.list",
    //     link: "/support-tickets",
    //   },
    //   {
    //     label: "menuitems.support-tickets.list.create",
    //     link: "/support-tickets/create",
    //   },
    // ],
  },
  {
    id: "inventory",
    label: "menuitems.inventory.text",
    icon: inventory,
    link: "/inventory",
    height: "22",
  },
  // {
  //   id: "development",
  //   label: "Development",
  //   icon: inventory,
  //   link: "/development",
  //   height: "22",
  // },
  {
    id: "integrations",
    label: "menuitems.integrations.text",
    icon: integration,
    link: "/integrations",
    height: "22",
  },
  {
    id: "profile",
    label: "menuitems.profile.text",
    icon: profile,
    link: "/account",
    height: "22",
  },
  {
    id: "users-control",
    label: "menuitems.users-control.text",
    icon: profile,
    link: "/users-control",
    height: "22",
  },
  // {
  //   id: "freights",
  //   label: "menuitems.freights.text",
  //   icon: freight,
  //   link: "/freights",
  //   height: "22",
  // },
];
